import { http } from '@/utils'
import createCrud from './crud'
import dependencies from './applications/dependencies'
import vulnerabilities from './applications/vulnerabilities'
import branches from './applications/branches'

export default createCrud({
  resource: 'applications',
  state: {
    initialState: {}
  },
  modules: {
    dependencies,
    vulnerabilities,
    branches
  },
  actions: {
    async syncApplication ({ getters, state }) {
      await http.post(getters.uri(`${state.single.id}/sync`))
    }
  }
});
